import './main.scss';
import Downloads from '../../components/downloads';
import Instructions from '../../components/instructions';
import Support from '../../components/support';
import useWindowWidth from '../../hooks/useWindowWidth';

const Main: React.FC = () => {
    const { screen } = useWindowWidth();

    return (
        <>
            <Downloads screen={screen} />
            <Instructions />
            <Support screen={screen} />
        </>
    );
};

export default Main;
